import styled from 'styled-components';

export const ComponentCard = styled.div<{ selected?: boolean; expanded?: boolean }>`
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[200])};
	border-radius: 8px;
	padding: 16px;
	transition: all 0.2s ease;
	min-height: 140px;
	display: flex;
	flex-direction: column;
	gap: 12px;

	&:hover {
		border-color: ${({ theme, selected }) => (selected ? theme.blue[500] : theme.gray[400])};
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	}
`;

export const ComponentName = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
`;

export const ComponentTag = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
`;

export const ComponentPreview = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 60px;
	max-height: 120px;
	width: 100%;
	flex: 0 1 auto;
`;

export const ComponentGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(180px, 280px));
	gap: 24px;
	width: 100%;
	justify-content: start;
`;

export const PropsEditor = styled.div`
	margin-top: 16px;
	padding-top: 16px;
	border-top: 1px solid ${({ theme }) => theme.gray[200]};
`;

export const PropsEditorHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
`;

export const PropsEditorTitle = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const PropsEditorReset = styled.button`
	font-size: 12px;
	color: ${({ theme }) => theme.blue[500]};
	background: none;
	border: none;
	padding: 4px 8px;
	border-radius: 4px;
	transition: background 0.2s ease;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const PropsEditorList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const PropsEditorItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const PropsEditorLabel = styled.label`
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[800]};
	display: flex;
	align-items: center;
	gap: 4px;
`;

export const PropsEditorRequired = styled.span`
	color: ${({ theme }) => theme.red[500]};
`;

export const PropsEditorDescription = styled.span`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
	font-weight: normal;
	margin-left: 4px;
`;

export const PropsEditorInput = styled.div`
	width: 100%;
`;

export const PropsEditorDefault = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
	font-style: italic;
`;

export const PropsEditorEmpty = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	text-align: center;
	padding: 16px;
`;
